export const GET_APPLICANTS = "GET_APPLICANTS";
export const ADD_APPLICANT = "ADD_APPLICANT";
export const EDIT_APPLICANT = "EDIT_APPLICANT";
export const GET_APPLICANT = "GET_APPLICANT";
export const RESET_APPLICANT = "RESET_APPLICANT";
export const ERROR_APPLICANT = "ERROR_APPLICANT";
export const GET_ALL_APPLICANTS = "GET_ALL_APPLICANTS";
                    